<template>
  <el-table
    v-if="attachments.length > 0"
    v-loading="isLoading"
    :data="attachments"
    stripe
  >
    <el-table-column
      label="Name"
    />

    <el-table-column
      label="Type"
    />

    <el-table-column
      label="Created At"
    />

    <el-table-column
      label="Actions"
      align="right"
    />
  </el-table>

  <p
    v-else
    v-loading="isLoading"
    class="text-center text-muted py-3"
  >
    No Data
  </p>
</template>

<script>
export default {
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      attachments: []
    }
  },
  mounted () {
    // @todo
  }
}
</script>
